module.exports = "https://static.cdns.space/tarot-temp/img/the-hanged-man.08dfa8a7.webp";